import { getOutlineWidth as getGlobalOutlineWidth } from './global';
export function getOutlineWidth(transformer) {
    const globalOutlineWidth = getGlobalOutlineWidth(transformer);
    return Object.freeze({
        default: { value: globalOutlineWidth.default },
    });
}
